import { useThemeSlice } from "./StatusBadge.jsx";

export function UnderlineTabs({ tabs, activeTab, onChange, paddingX = 18 }) {
  const { c, accentHex: A } = useThemeSlice();

  return (
    <div
      style={{
        display: "flex",
        gap: 4,
        padding: `0 ${paddingX}px`,
        borderBottom: `1px solid ${c.divider}`,
        background: c.sb,
        overflowX: "auto",
        flexShrink: 0,
      }}
    >
      {tabs.map((tab) => {
        const active = activeTab === tab.id;
        return (
          <button
            key={tab.id}
            type="button"
            onClick={() => onChange(tab.id)}
            aria-selected={active}
            style={{
              border: "none",
              background: "transparent",
              color: active ? A : c.mid,
              fontSize: 13,
              fontWeight: active ? 700 : 500,
              padding: "14px 16px",
              minHeight: 46,
              cursor: "pointer",
              borderBottom: active ? `3px solid ${A}` : "3px solid transparent",
              marginBottom: -1,
              whiteSpace: "nowrap",
            }}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
}
